import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes, faAngleRight, faAngleDown } from "@fortawesome/free-solid-svg-icons";
import Clogo from "../../assets/assets/logo-b.png";
import NavItems from "../utils/NavLinks";
import { NavLink } from "react-router-dom";

const Navbar = ({ navLinks }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);
  const [expandedCategory, setExpandedCategory] = useState(null);
  const [showProductsCategories, setShowProductsCategories] = useState(false);

  const toggleMobileNav = () => {
    setIsNavOpen((prevState) => !prevState);
    setIsOpen((prevState) => !prevState);
    setExpandedCategory(null); // Reset expanded category when closing nav
    setShowProductsCategories(false); // Reset products categories when closing nav
  };

  const toggleCategory = (categoryTitle) => {
    setExpandedCategory(expandedCategory === categoryTitle ? null : categoryTitle);
  };

  const toggleProductsCategories = () => {
    setShowProductsCategories((prev) => !prev);
    setExpandedCategory(null); // Reset any expanded category when toggling products
  };

  const handleScroll = () => {
    if (window.scrollY > 0) {
      setHasScrolled(true);
    } else {
      setHasScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const renderNavOptions = (options, categories) => {
    // Handle new categorized structure
    if (categories) {
      // Find specific categories and arrange in desired order
      const databasesCategory = categories.find(cat => cat.title === "Databases");
      const dealDigestCategory = categories.find(cat => cat.title === "Deal Digest Newsletter");
      const quickLinksCategory = categories.find(cat => cat.title === "Quick Links");
      const directoryCategory = categories.find(cat => cat.title === "Directory");
      const otherProductsCategory = categories.find(cat => cat.title === "Other Products & Services");
      // const mcadownloader = categories.find(cat => cat.title === "MCA Downloader");
      
      // Arrange categories in the desired order: [Databases, Deal Digest, Quick Links], [Directory, Other Products]
      const firstRowCategories = [databasesCategory, dealDigestCategory, quickLinksCategory].filter(Boolean);
      const secondRowCategories = [directoryCategory, otherProductsCategory].filter(Boolean);
      
      return (
        <div className="mt-2 px-10 hidden group-hover:block absolute left-1/2 transform -translate-x-1/2 bg-white shadow-xl border border-gray-200 rounded-xl z-50 max-w-6xl w-max">
          {/* Desktop Layout: 3 columns with specific groupings */}
          <div className="hidden lg:block p-6">
            <div className="flex gap-x-[80px] w-max">
              {/* Column 1: Databases + Directory */}
              <div className="flex flex-col gap-y-6">
                <div className="w-max">
                  <h4 className="text-[16px] font-bold text-black pb-2 mb-3 whitespace-nowrap">
                    Databases
                  </h4>
                  <ul className="space-y-2">
                    {databasesCategory?.items.map((item) => (
                      <li key={item.name}>
                        <a
                          href={item.to}
                          className="text-gray-500 hover:text-black text-sm leading-relaxed block py-1 transition-colors duration-200 whitespace-nowrap"
                        >
                          {item.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="w-max">
                  <h4 className="text-[16px]  font-bold text-black pb-2 mb-3 whitespace-nowrap">
                    Directory
                  </h4>
                  <ul className="space-y-2">
                    {directoryCategory?.items.map((item) => (
                      <li key={item.name}>
                        <a
                          href={item.to}
                          className="text-gray-500 hover:text-black text-sm leading-relaxed block py-1 transition-colors duration-200 whitespace-nowrap"
                        >
                          {item.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
                {/* <div className="w-max">
                  <h4 className="text-[16px]  font-bold text-black pb-2 mb-3 whitespace-nowrap">
                    MCA Downloader
                    <span 
                      className="ml-3 bg-orange-500 text-white px-2 py-[2px] text-xs rounded-tl-md rounded-br-md rounded-tr-none rounded-bl-none"
                    >
                      New
                    </span>
                  </h4>
                  <ul className="space-y-2">
                    {mcadownloader?.items.map((item) => (
                      <li key={item.name}>
                        <NavLink
                          to={item.to}
                          className="text-gray-500 hover:text-black text-sm leading-relaxed block py-1 transition-colors duration-200 whitespace-nowrap"
                        >
                          {item.name}
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                </div> */}
              </div>

              {/* Column 2: Deal Digest Newsletter + Other Products & Services */}
              <div className="flex flex-col gap-y-6">
                <div className="w-max">
                  <h4 className="text-[16px]  font-bold text-black pb-2 mb-3 whitespace-nowrap">
                    Deal Digest Newsletter
                  </h4>
                  <ul className="space-y-2">
                    {dealDigestCategory?.items.map((item) => (
                      <li key={item.name}>
                        <a
                          href={item.to}
                          className="text-gray-500 hover:text-black text-sm leading-relaxed block py-1 transition-colors duration-200 whitespace-nowrap"
                        >
                          {item.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="w-max">
                  <h4 className="text-[16px]  font-bold text-black pb-2 mb-3 whitespace-nowrap">
                    Other Products & Services
                  </h4>
                  <ul className="space-y-2">
                    {otherProductsCategory?.items.map((item) => (
                      <li key={item.name}>
                        <a
                          href={item.to}
                          className="text-gray-500 hover:text-black text-sm leading-relaxed block py-1 transition-colors duration-200 whitespace-nowrap"
                        >
                          {item.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* Column 3: Quick Links */}
              <div className="flex flex-col">
                <div className="w-max">
                  <h4 className="text-[16px]  font-bold text-black pb-2 mb-3 whitespace-nowrap">
                    Quick Links
                  </h4>
                  <ul className="space-y-2">
                    {quickLinksCategory?.items.map((item) => (
                      <li key={item.name}>
                        <a
                          href={item.to}
                          className="text-gray-500 hover:text-black text-sm leading-relaxed block py-1 transition-colors duration-200 whitespace-nowrap"
                        >
                          {item.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Tablet Layout: Scrollable horizontal */}
          <div className="hidden md:block lg:hidden p-4 max-w-screen-md overflow-x-auto">
            <div className="flex gap-6 min-w-max pb-2">
              {categories.map((category) => (
                <div key={category.title} className="min-w-44 flex-shrink-0">
                  <h4 className="text-sm font-bold text-black pb-2 mb-3">
                    {category.title}
                  </h4>
                  <ul className="space-y-2">
                    {category.items.map((item) => (
                      <li key={item.name}>
                        <a
                          href={item.to}
                          className="text-gray-500 hover:text-black text-sm leading-relaxed block py-1 transition-colors duration-200"
                        >
                          {item.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>

          {/* Mobile Layout: Accordion style */}
          <div className="md:hidden p-4 max-h-[70vh] overflow-y-auto">
            {categories.map((category) => (
              <div key={category.title} className="border-b border-gray-200 last:border-b-0">
                <button
                  onClick={() => toggleCategory(category.title)}
                  className="w-full text-left py-3 flex items-center justify-between text-black font-semibold"
                >
                  {category.title}
                  <FontAwesomeIcon
                    icon={expandedCategory === category.title ? faTimes : faBars}
                    size="sm"
                    className="text-black"
                  />
                </button>
                {expandedCategory === category.title && (
                  <div className="pb-3">
                    <ul className="space-y-2 pl-4">
                      {category.items.map((item) => (
                        <li key={item.name}>
                          <a
                            href={item.to}
                            className="text-gray-500 hover:text-black text-sm leading-relaxed block py-2 transition-colors duration-200"
                            onClick={() => setIsNavOpen(false)}
                          >
                            {item.name}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      );
    }
    
    // Handle old options structure (fallback)
    if (options) {
      return (
        <div className="mt-2 p-2 min-w-48 hidden group-hover:flex flex-col bg-[aliceblue] gap-1 z-30 rounded-md lg:fixed">
          {options.map((option) => (
            <a
              href={option.to}
              key={option.name}
              className="py-2 px-1.5 hover:bg-blue-50 text-black hover:text-black"
            >
              {option.name}
            </a>
          ))}
        </div>
      );
    }
    return null;
  };

  const renderNavItem = (link) => {
    if (link.name === "Customer Login") {
      return (
        <a
          href={link.to}
          className="inline-block px-4 py-2 bg-[#bc8b20] text-white rounded-md hover:bg-[#dfa018]  transition-colors duration-300 text-sm font-medium"
        >
          {link.name}
        </a>
      );
    }

    return (
      <NavItems to={link.to} page={link.name} options={link.options} categories={link.categories} />
    );
  };

  return (
    <div
      className={`py-2.5 px-3 flex items-center justify-between lg:mx-auto lg:justify-evenly bg-white lg:sticky w-full top-0 z-50 transition-shadow duration-300 ${
        hasScrolled ? "shadow-md" : ""
      }`}
    >
      <div className="flex items-center justify-between w-full">
        <div>
          <a href="/">
            <img
              src={Clogo}
              alt="VI logo Private Company Data, PE & VC Deals, and Transactions"
              className="mx-2 w-32 sm:w-36 z-30 cursor-pointer"
            />
          </a>
        </div>
        <div
          className={`flex-col text-sm ${
            isNavOpen
              ? "mt-4 p-2 w-[85vw] absolute top-12 right-4 z-30 flex justify-center gap-4 bg-white rounded-lg transition-all duration-300 ease-in-out shadow-lg border sm:w-4/12 lg:w-1/4"
              : "hidden"
          } lg:static lg:flex lg:flex-row lg:items-center lg:justify-end lg:bg-transparent lg:shadow-none lg:border-none`}
        >
          {navLinks.map((link) => (
            <div
              className={`px-2 py-1 lg:py-2 lg:px-4 group rounded-md ${isNavOpen ? 'border-b border-gray-200 last:border-b-0' : ''}`}
              key={link.name}
            >
              {/* Mobile navigation handling */}
              {isNavOpen ? (
                <div className="lg:hidden w-full">
                  {/* Handle Products dropdown specially on mobile */}
                  {link.name === "Products" && link.categories ? (
                    <div className="w-full">
                      {/* Main Products button with right arrow */}
                      <button
                        onClick={toggleProductsCategories}
                        className="w-full text-left py-3 flex items-center justify-between text-black font-semibold"
                      >
                        {link.name}
                        <FontAwesomeIcon
                          icon={showProductsCategories ? faAngleDown : faAngleRight}
                          size="sm"
                          className="text-black"
                        />
                      </button>

                      {/* Show categories when Products is expanded */}
                      {showProductsCategories && (
                        <div className="pl-4">
                          {link.categories.map((category) => (
                            <div key={category.title} className="border-b border-gray-200 last:border-b-0">
                              <button
                                onClick={() => toggleCategory(category.title)}
                                className="w-full text-left py-2 flex items-center justify-between text-black font-medium text-sm"
                              >
                                {category.title}
                                <FontAwesomeIcon
                                  icon={expandedCategory === category.title ? faAngleDown : faAngleRight}
                                  size="xs"
                                  className="text-black"
                                />
                              </button>
                              {expandedCategory === category.title && (
                                <div className="pb-2">
                                  <ul className="space-y-1 pl-3">
                                    {category.items.map((item, index) => (
                                      <li key={item.name} className={`${index !== category.items.length - 1 ? 'border-b border-gray-100' : ''}`}>
                                        <a
                                          href={item.to}
                                          className="text-gray-600 hover:text-black text-xs leading-relaxed block py-2 transition-colors duration-200"
                                          onClick={() => {
                                            setIsNavOpen(false);
                                            setShowProductsCategories(false);
                                            setExpandedCategory(null);
                                          }}
                                        >
                                          {item.name}
                                        </a>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  ) : (
                    // Other navigation items on mobile
                    <div className="w-full">
                      <a
                        href={link.to}
                        className="w-full text-left py-3 block text-black font-medium transition-colors duration-200"
                        onClick={() => setIsNavOpen(false)}
                      >
                        {link.name}
                      </a>
                    </div>
                  )}
                </div>
              ) : (
                // Desktop navigation items and dropdown
                <>
                  {renderNavItem(link)}
                  <div className="hidden lg:block">
                    {renderNavOptions(link.options, link.categories)}
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
      <div
        onClick={toggleMobileNav}
        className="mr-1 p-2 absolute right-5 z-30 rounded-md cursor-pointer lg:hidden bg-white mt-2"
      >
        <FontAwesomeIcon
          icon={isOpen ? faTimes : faBars}
          size="lg"
          className={`mr-4 w-8 duration-75 cursor-pointer ${
            isOpen ? "text-[#bc8b20]" : "text-gray-500"
          }`}
        />
      </div>
    </div>
  );
};

export default Navbar;